import { StorageUnitType } from 'store/storageunits/types';

export const splitName = (type: StorageUnitType, name: string): string => {
  if (type === StorageUnitType.File) {
    if (!name.includes('.')) {
      return name;
    }
    name = name.substring(0, name.lastIndexOf('.'));
  }
  return name;
};

export const uppercase = (name: string) => {
  return name.charAt(0).toUpperCase() + name.slice(1);
};
